"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Llm = void 0;
exports.Llm = {
    Gpt4OMini: "gpt-4o-mini",
    Gpt4O: "gpt-4o",
    Gpt4: "gpt-4",
    Gpt4Turbo: "gpt-4-turbo",
    Gpt41: "gpt-4.1",
    Gpt41Mini: "gpt-4.1-mini",
    Gpt41Nano: "gpt-4.1-nano",
    Gpt35Turbo: "gpt-3.5-turbo",
    Gemini15Pro: "gemini-1.5-pro",
    Gemini15Flash: "gemini-1.5-flash",
    Gemini20Flash: "gemini-2.0-flash",
    Gemini20FlashLite: "gemini-2.0-flash-lite",
    Gemini25Flash: "gemini-2.5-flash",
    ClaudeSonnet4: "claude-sonnet-4",
    Claude37Sonnet: "claude-3-7-sonnet",
    Claude35Sonnet: "claude-3-5-sonnet",
    Claude35SonnetV1: "claude-3-5-sonnet-v1",
    Claude3Haiku: "claude-3-haiku",
    GrokBeta: "grok-beta",
    CustomLlm: "custom-llm",
    Gemini20FlashLite001: "gemini-2.0-flash-lite-001",
    Gemini20Flash001: "gemini-2.0-flash-001",
    Gemini15Flash002: "gemini-1.5-flash-002",
    Gemini15Flash001: "gemini-1.5-flash-001",
    Gemini15Pro002: "gemini-1.5-pro-002",
    Gemini15Pro001: "gemini-1.5-pro-001",
    ClaudeSonnet420250514: "claude-sonnet-4@20250514",
    Claude37Sonnet20250219: "claude-3-7-sonnet@20250219",
    Claude35Sonnet20240620: "claude-3-5-sonnet@20240620",
    Claude35SonnetV220241022: "claude-3-5-sonnet-v2@20241022",
    Claude3Haiku20240307: "claude-3-haiku@20240307",
    Gpt4120250414: "gpt-4.1-2025-04-14",
    Gpt41Mini20250414: "gpt-4.1-mini-2025-04-14",
    Gpt41Nano20250414: "gpt-4.1-nano-2025-04-14",
    Gpt4OMini20240718: "gpt-4o-mini-2024-07-18",
    Gpt4O20241120: "gpt-4o-2024-11-20",
    Gpt4O20240806: "gpt-4o-2024-08-06",
    Gpt4O20240513: "gpt-4o-2024-05-13",
    Gpt40613: "gpt-4-0613",
    Gpt40314: "gpt-4-0314",
    Gpt4Turbo20240409: "gpt-4-turbo-2024-04-09",
    Gpt35Turbo0125: "gpt-3.5-turbo-0125",
    Gpt35Turbo1106: "gpt-3.5-turbo-1106",
};
